import axios from "axios";
import store from "~/store";
import i18n from "~/plugins/i18n";
import { createApp } from "vue"; // Import createApp
import { AlertPlugin } from "~/plugins/AlertPlugin";

export const TYPE = Object.freeze({
  AZURE: 1,
  SUGAR: 2,
});
// Request interceptor
axios.interceptors.request.use(
  async (request) =>
  {

    switch (request.type)
    {
      case null: // default
      case undefined:
        const token = store.getters["auth/token"];
        if (token && !request.azure)
        {
          request.headers.Authorization = `Bearer ${token}`;
        }
        break;
      case TYPE.AZURE:

        if (import.meta.env.VITE_AZURE_ACCESS_TOKEN)
        {
          const Base64Token = btoa(':' +
            import.meta.env.VITE_AZURE_ACCESS_TOKEN
          );
          request.headers.Authorization = `Basic ${Base64Token}`;
        }
        break;

      case TYPE.SUGAR:
        {
          const token = store.getters["auth/token"];
          if (token)
          {
            request.headers.Authorization = `Bearer ${token}`;
          }

          if (import.meta.env.VITE_TT_FEAT_SUGARCRM)
          {
            if (!store.getters["auth/sugar_access_token"])
            {
              await store.dispatch("auth/sugarConnection");
            }
          }
        }
    }
    const locale = store.getters["lang/locale"];
    if (locale)
    {
      request.headers["Accept-Language"] = locale;
    }

    // request.headers['X-Socket-Id'] = Echo.socketId()


    return request;

  }, (error) =>
{
  return Promise.reject(error);
});

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  async (error) =>
  {
    const status = error.response?.status;
    const originalRequest = error.config ?? error.request;

    const app = createApp({});
    app.use(AlertPlugin).use(i18n);

    if (!status)
    {
      console.error("Network or CORS error:", error);
      throw error;
    }
    if (status >= 500)
    {
      let errors = error.response.data.errors;
      let errors_arr = [];
      for (let field of Object.keys(errors))
      {
        errors_arr.push(errors[field][0]);
      }
      app.config.globalProperties.$showAlert({
        icon: "error",
        title: "error_alert_title",
        html: errors_arr.join("<br />"),
      });
    }

    if (status === 422)
    {
      let errors = error.response.data.errors;
      let errors_arr = [];
      for (let field of Object.keys(errors))
      {
        errors_arr.push(errors[field][0]);
      }
      app.config.globalProperties.$showAlert({
        icon: "error",
        title: "error_alert_title",
        html: errors_arr.join("<br />"),
      });
    }

    if ((status === 401) && store.getters["auth/check"] && originalRequest?.type !== TYPE.SUGAR)
    {
      app.config.globalProperties.$showAlert({
        icon: "warning",
        title: "token_expired_alert_title",
        html: i18n.t("token_expired_alert_text"),
      });
    }

    return Promise.reject(error);
  }
);
